import React from 'react';
import { useSidebar } from '../../context/SidebarContext';

const ContentContainer = ({ children }) => {
  const { isCollapsed } = useSidebar();

  return (
    <div className={`global-content ${isCollapsed ? 'sidebar-collapsed' : ''}`}>
      {children}
    </div>
  );
};

export default ContentContainer;
